import { useFormDetailsState } from "../../context/FormDetailsContext";
import FullHeight from "./FullHeight";

const SliderPage = ({ children, title }) => {
  const {
    footerHeight: { order_form },
  } = useFormDetailsState();

  const id = title.replaceAll(" ", "");
  return (
    <FullHeight id={id} className="slider-page" footerHeight={order_form}>
      <h1 className="mb-5">{title}</h1>
      <div>{children}</div>
    </FullHeight>
  );
};

export default SliderPage;
